module.exports = __webpack_public_path__ + "static/media/metart-5f31aef6.20a2ecc8.jpg";